import { getClassFunction } from '@helpers/functions';

const getClass = getClassFunction('kf-o-property-listings');
const getClassItem = getClassFunction('kf-o-property-listing-item');

const elements = document.querySelectorAll(getClass(undefined, { checkAttached: true }));

const handler = (el: HTMLElement) => {
  const items = el.querySelectorAll<HTMLElement>(getClassItem());

  [].forEach.call(items, (item: HTMLElement) => {
    let link: HTMLAnchorElement | null = null;

    if (item.hasAttribute('data-json')) {
      link = item as HTMLAnchorElement;
    } else {
      link = item.querySelector<HTMLAnchorElement>('a');
    }
    if (!link) return;
    const data = link.dataset.json;
    const tcFuntion = window.tC?.event?.property_listings_block;

    if (!tcFuntion || !data) return;

    link.addEventListener('click', (e) => {
      tcFuntion(e, JSON.parse(data));
    });
  });
};

const init = () => {
  [].forEach.call(elements, (el: HTMLElement) => {
    handler(el);
  });
};

init();
